export const GET_PAGE_BY_SLUG_METHOD = (slug: string, preview: boolean) => {
  return `
query {
  pageCollection(where: {slug: "${slug}"}, preview: ${preview}){
    items {
      name
      latestReviewDate
      pageUpdateDate
      authorName
      reviewName
      reviewRole
      pageLanguage
      content {
        __typename
        ... on Landingpage {
          sys {
            id
          }
        }
        ... on InsuranceClaimPage {
          sys {
            id
          }
        }
        ... on Insurancepage {
          sys {
            id
          }
        }
        ... on Standardpage {
          sys {
            id
          }
        }
        ... on Eventpage{
          sys {
            id
          }
        }
        ... on Newspage{
          sys {
            id
          }
        }
        ... on Reportpage{
          sys {
            id
          }
        }
      }
      seo {
        title
        description
        keywords
        canonicalUrl
        ivSocialMediaImage
        noIndex
        noFollow
      }
      hideContactsectionInFooter
    }
}
}
`;
};
